<template>
    <div style="width: 100%; height: 100%; min-width: 1500px; padding: 10px;">
        <div style="display: flex; flex-direction: column; flex: 1; height: 100%; min-width: 1500px;">
            <modal :showDialog="activeModal == 'INFO'" @close="closeModal" :title="activeObject != null ? activeObject.column.headerText : ''">
                <system-alarms-details-modal :data="activeObject" :day="activeDay" :apiMethodName="(activeObject != null && activeObject.column.field != 'visits') ? 'getDeviceAlarmFromDay' : 'getVisitsForDay'" :value="activeValue"></system-alarms-details-modal>
            </modal>
            <modal :show-dialog="activeModal === 'SOFTWAREHISTORY'" @close="closeModal" :title="activeObject != null ? activeObject.column.headerText : ''">
                <devices-software-history-modal :device="activeObject"></devices-software-history-modal>
            </modal>
            <modal :showDialog="activeModal == 'LOADCELLDATA'" @close="closeModal" :title="activeDeviceId != null ? 'Calibration ' + systemName : ''">
                <load-cell-data-modal :systemId="systemId" :deviceId="activeDeviceId"></load-cell-data-modal>
            </modal>
            <modal :showDialog="activeModal == 'DEVICEALARMS'" @close="closeModal" :title="activeObject != null ? activeObject.column.headerText : ''">
                <sci-chart-device-alarm-modal :field="activeObject"/>
            </modal>
            <modal :showDialog="activeModal == 'OK'" @close="closeModal" :title="activeObject != null ? activeObject.column.headerText : ''">
                <img src="@/assets/img/tenor.gif"/>
            </modal>
            <ejs-grid ref="grid" height="100%" width="100%" :toolbar="toolbar" :toolbarClick="toolbarClick" :sortSettings="sortSettings" :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings" :dataBound="dataBound" :dataSource="data" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" style="position: relative" :excelExportComplete='exportComplete' :pdfExportComplete='exportComplete'>
                <e-columns>
                    <e-column field="number" :headerText="$t('Number')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="type" :headerText="$t('Type')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="mode" :headerText="$t('Mode')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="deviceVersion" :filter="filterCheckbox"  :template="buttonTemplate" :headerText="$t('Software')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="status" :headerText="$t('Status')" :filter="filterCheckbox" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="calibration" onClick="showCalibration" :headerText="$t('Calibration')" textAlign="Left" :template="calibrationTemplate" :customAttributes="customAttributes"></e-column>
                    <e-column field="photocell" :headerText="$t('Photocell') + ' (Y/T)'" :template="todayYesterdayTemplate" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="loadcell" :headerText="$t('Loadcell') + ' (Y/T)'" :template="todayYesterdayTemplate" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="connection" :headerText="$t('Connection') + ' (Y/T)'" :template="todayYesterdayTemplate" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="visits" :headerText="$t('Visits') + ' (Y/T)'" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="errorLogs" :headerText="$t('ErrorLogs') + ' (Y/T)'" textAlign="Left" :template="errorsTodayYesterdayTemplate" :customAttributes="customAttributes"></e-column>
                    <e-column field="initPhotodelay" :headerText="$t('InitPhotodelay')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="photodelay" :headerText="$t('Photodelay')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                </e-columns>
            </ejs-grid>
        </div>
    </div>
</template>

<script>
import { getSystemDevices } from '@api'
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import Vue from 'vue'
import SystemAlarmsDetailsModal from '../../components/Systems/SystemAlarmsDetailsModal.vue';
import Modal from '@/components/Modal.vue';
import DevicesSoftwareHistoryModal from "@/components/Systems/Devices/DevicesSoftwareHistoryModal";
import LoadCellDataModal from '@/components/Devices/LoadCellDataModal';
import SciChartDeviceAlarmModal from '../../components/Systems/Devices/SciChartDeviceAlarmModal.vue';

var context = null

export default {
    props: ['systemName', 'systemId'],
    components: {
        DevicesSoftwareHistoryModal,
        SystemAlarmsDetailsModal,
        Modal,
        LoadCellDataModal,
        SciChartDeviceAlarmModal,
    },
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport ]
    },
    data() {
        return {
            data: [],
            activeModal: "NONE",
            activeObject: null,
            activeDay: null,
            activeValue: null,
            activeDeviceId: null,
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [
                { text: this.$t('Devices'), id: 'table-device-title',},
                { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right',},
                { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export'},
                { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export'},
                { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export'},
                'Search',
            ],
            sortSettings: {
                columns: [
                    { field: 'number', direction: 'Ascending' }
                ]
            },
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "Menu",
            },
            filterCheckbox: {
                type: "CheckBox",
            },
            customAttributes: { class: "customcss" },
            buttonTemplate: function() {
                return {
                    template: Vue.component('buttonTemplate', {
                        template: `<button v-on:click="openModal" class="device-software-version-button">{{text}}</button>`,
                        data: function() {
                            return {
                                data: {}
                            }
                        },
                        computed: {
                            text() {
                                return this.data.deviceVersion
                            }
                        },
                        methods: {
                            openModal(){
                                context.showModal(this.data, 'SOFTWAREHISTORY', null, null)
                            }
                        }
                    })
                }
            },
            calibrationTemplate: function() {
                return {
                    template: Vue.component('calibrationTemplate', {
                        template: `<div style="cursor: pointer;" v-on:click="showModal()" id="calibrationId">{{tilt}}</div>`,
                        data: function() {
                            return {
                                data: {},
                            }
                        },
                        computed: {
                            tilt: function() {
                                return this.data.calibration.includes("0001-01-01T01:00:00") ? "-" : this.data.calibration.split("T")[0]
                            }
                        },
                        methods: {
                            showModal: function() {
                                context.showCalibrationModal(this.data);
                            }
                        }
                    })
                }
            },
            todayYesterdayTemplate() {
                return {
                    template: Vue.component('todayYesterdayTemplate', {
                        template: '<div style="cursor: pointer;" v-on:click="showModal()">{{ errorsText }}</div>',
                        data() {
                            return { data: {} }
                        },
                        computed: {
                            field() {
                                return this.data.column.field
                            },
                            errorsText() {
                                return `${this.data[this.field + "ErrorsYesterday"] == 0 ? "-" : this.data[this.field + "ErrorsYesterday"] } / ${this.data[this.field + "ErrorsToday"] == 0 ? "-" : this.data[this.field + "ErrorsToday"]}`
                            }
                        },
                        methods: {
                            showModal() {
                                if(this.data[this.field + "ErrorsYesterday"] == 0 && this.data[this.field + "ErrorsToday"] == 0 ){
                                    context.showOkModal(this.data)
                                    return;
                                }
                                context.showGraph(this.data)
                            }
                        }
                    })
                }
            },
            errorsTodayYesterdayTemplate() {
                return {
                    template: Vue.component('errorsTodayYesterdayTemplate', {
                        template: '<div>{{ data["errorsYesterday"] == 0 ? "-" : data["errorsYesterday"] }} / {{ data["errorsToday"] == 0 ? "-" : data["errorsToday"] }}</div>',
                        data() {
                            return { data: {} }
                        },
                    })
                }
            }
        }
    },
    methods: {
        async getData() {
            this.$store.dispatch('set_loading', true)
            this.data = await getSystemDevices(this.systemId);

            this.data.forEach(d => {
                d.status = d.status != null ? [this.$t("Up"), this.$t("Down")][d.status] : "-"
                d.photodelay += "s"
                d.mode = [this.$t("Normal"), this.$t("Restricitve"), this.$t("FreeAccess")][d.mode]
                d.initPhotodelay += "s"

                d.visits = `${d.visitsYesterday} / ${d.visitsToday}`
            })

            this.$store.dispatch('set_loading', false)
        },
        dataBound: function () {
            this.$refs.grid.autoFitColumns();
        },
        toolbarClick: function (args) {
            switch (args.item.id) {
                case "table-system-title":
                    this.$router.push({
                        name: "systems"
                    })
                    break;
                case "table-device-title":
                    this.getData();
                    break;
                case "pdf-export":
                    this.data.forEach((item) => {
                        item.photocell.reverse()
                        item.loadcell.reverse()
                        item.connection.reverse()
                        item.visits.reverse()
                        item.errorLogs.reverse()
                    })
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.data.forEach((item) => {
                        item.photocell.reverse()
                        item.loadcell.reverse()
                        item.connection.reverse()
                        item.visits.reverse()
                        item.errorLogs.reverse()
                    })
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.data.forEach((item) => {
                        item.photocell.reverse()
                        item.loadcell.reverse()
                        item.connection.reverse()
                        item.visits.reverse()
                        item.errorLogs.reverse()
                    })
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                  this.$refs.grid.clearFiltering();
                  break;
            }
        },
        exportComplete(args) {
            this.data.forEach((item) => {
                item.photocell.reverse()
                item.loadcell.reverse()
                item.connection.reverse()
                item.visits.reverse()
                item.errorLogs.reverse()
            })
        },
        showModal(obj, mode, day, value){
            this.activeObject = obj
            this.activeDay = day
            this.activeModal = mode
            this.activeValue = value
        },
        closeModal(mode){
            this.activeModal = 'NONE'
            this.activeObject = null
            this.activeDay = null
            this.activeValue = null
            if(mode == 'getData')
                this.getData()
        },
        showCalibrationModal(data) {
            this.activeDeviceId = data.id
            this.activeModal = 'LOADCELLDATA'
        },
        showOkModal(args) {
            this.activeObject = args;
            this.activeModal = "OK"
        },
        showGraph(args) {
            this.activeObject = args;
            this.activeModal = "DEVICEALARMS"
        }
    },
    mounted: async function () {
        context = this
        await this.getData()
    }
}
</script>

<style>
.device-software-version-button {
	border: 1px #ddd solid;
	padding: 5px 10px;
	background: none;
}

.device-software-version-button:hover {
	background: #bbbbbb;
}
</style>



// WEBPACK FOOTER //
// src/views/System/SettingsDevices.vue